import { __exports as e } from "../../../../_virtual/safeHTMLElement.js";
import { e as t } from "../../../exenv/index.js";
Object.defineProperty(e, "__esModule", {
  value: !0
});
e.canUseDOM = e.SafeNodeList = e.SafeHTMLCollection = void 0;
var o = t, r = i(o);
function i(n) {
  return n && n.__esModule ? n : { default: n };
}
var a = r.default, l = a.canUseDOM ? window.HTMLElement : {};
e.SafeHTMLCollection = a.canUseDOM ? window.HTMLCollection : {};
e.SafeNodeList = a.canUseDOM ? window.NodeList : {};
e.canUseDOM = a.canUseDOM;
e.default = l;
